import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=fe5d4e30&scoped=true&"
import script from "./SubscriptionForm.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionForm.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=fe5d4e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5d4e30",
  null
  
)

export default component.exports